import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Check, ChevronRight, Ban } from 'lucide-react';
import { FaEye, FaEyeSlash, FaLongArrowAltRight, FaLinkedin } from "react-icons/fa";
import { Formik, Form } from "formik";
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';
import { FaGooglePlay, FaApple } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useEmailVerification } from '../../hooks/auth/useEmailVerification';
import { useResetPassword } from '../../hooks/auth/useResetPassword';
import { PasswordChangeFormSchema } from '../../utils/yupSchemas';
import { DownloadAppButton } from '../../components/button';
import { Button } from '../../components/button';
import { TextInput } from '../../components/forms/inputs';

const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const { resetPassword } = useResetPassword();
    const token = new URLSearchParams(window.location.search).get('token');
    const navigateTo = useNavigate();

    const handleTogglePassword = () => {
      setShowPassword(!showPassword);
    }; 

    return (
       <main className='h-screen w-full flex justify-center items-center'>
        <div className='w-11/12 md:w-4/12'>
        <Formik
                initialValues={{ new_password1: "", new_password2:"" }}
                validationSchema={PasswordChangeFormSchema}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    const { status, data } = await resetPassword({
                      password: values.new_password1,
                      //new_password2: values.new_password2,
                      token: token,
                    });
                    if(status===200){
                      toast.success(data.message);
                      navigateTo('/sign-in');
                    }
                    setSubmitting(false);
                  } catch (error) {
                    console.log(error, 'err')
                    if (error.message) {
                      toast.error(`${error.message}`);
                    } else if (error.request) {
                        toast.error('No response from server. Please try again later.');
                    } 
                  }
                }}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div>
                      <div className='relative'>
                        <TextInput
                          label='password'
                          name='new_password1'
                          type={showPassword ? "text" : "password"}
                          placeholder='************'
                          handleTogglePassword={handleTogglePassword}
                          passwordIcon={
                            showPassword ? (
                              <FaEye className='text-dark' />
                            ) : (
                              <FaEyeSlash className='text-dark' />
                            )
                          }
                        />
                      </div>
                      <div className='relative'>
                        <TextInput
                          label='confirm password'
                          name='new_password2'
                          type={showPassword ? "text" : "password"}
                          placeholder='****************'
                          handleTogglePassword={handleTogglePassword}
                          passwordIcon={
                            showPassword ? (
                              <FaEye className='text-dark' />
                            ) : (
                              <FaEyeSlash className='text-dark' />
                            )
                          }
                        />
                      </div>
                    </div>
                    <Button 
                    type='submit' disabled={isSubmitting}
                    icon={<FaLongArrowAltRight/>}
                    >
                      {
                        isSubmitting ? <span className="loading loading-spinner loading-xs"></span> : <span>Change Password</span>
                      }
                    </Button>
                  </Form>
                )}
            </Formik>
        </div>
       </main>
    );
}

export default ResetPassword;
